import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { Confrontation } from './';

import { ErrorComponent } from './';
import { CanActivate } from '@angular/router';
import { AuthGuardService } from './';

// Route Configuration
const sharedRoutes: Routes = [
  { 
    path: Confrontation.SERVERERROR,
    component: ErrorComponent,
    canActivate:[AuthGuardService]
  }
];

export const sharedRoutingProviders: any[] = [ AuthGuardService ];

export const sharedRouting: ModuleWithProviders = RouterModule.forChild(sharedRoutes)


// WEBPACK FOOTER //
// ./src/app/shared/shared.routes.ts